import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["rightAligned", "children"];
/**
 * From https://git.hubteam.com/HubSpot/customer-data-table/blob/master/framework-data-table/static-2.6700/js/contentRenderers/TruncateDiv.tsx
 * Copying customer-data-table's implementation as it fits perfectly to our needs.
 */

import styled from 'styled-components';
import { useCallback, useState } from 'react';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UITooltipContent from 'UIComponents/tooltip/UITooltipContent';
import { jsx as _jsx } from "react/jsx-runtime";
export const NoWrapDiv = styled.div.withConfig({
  displayName: "ListingLibTruncateDiv__NoWrapDiv",
  componentId: "tgswen-0"
})(["white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);
export default function ListingLibTruncateDiv(_ref) {
  let {
      rightAligned,
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [isTruncated, setIsTruncated] = useState(false);
  const handleMouseEnter = useCallback(({
    currentTarget
  }) => {
    setIsTruncated(currentTarget.scrollWidth > currentTarget.clientWidth);
  }, []);
  const TooltipContent = useCallback(() => /*#__PURE__*/_jsx(UITooltipContent, {
    children: children
  }), [children]);
  return /*#__PURE__*/_jsx(UITooltip, {
    Content: TooltipContent,
    maxWidth: 500,
    disabled: !isTruncated,
    children: /*#__PURE__*/_jsx(NoWrapDiv, Object.assign({
      className: rightAligned ? 'width-100 text-right' : '',
      onMouseEnter: handleMouseEnter
    }, rest, {
      children: children
    }))
  });
}